import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ImageInput } from "@/components/ImageInput";
import { api, errMsg } from "@/lib/api";

const EMPTY = { title: "", summary: "", content: "", category_id: "", image_url: "", author: "Redaksi" };

export default function ArticleEditor() {
  const { id } = useParams();
  const nav = useNavigate();
  const [f, setF] = useState(EMPTY);
  const [cats, setCats] = useState([]);
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v?.target ? v.target.value : v }));

  useEffect(() => {
    let live = true;
    api.get("/categories").then((r) => live && setCats(r.data));
    if (id) api.get(`/articles/${id}`).then((r) => live && setF({ ...EMPTY, ...r.data })).catch(() => live && toast.error("Berita tidak ditemukan"));
    else setF(EMPTY);
    return () => { live = false; };
  }, [id]);

  const save = async (e) => {
    e.preventDefault();
    if (!f.category_id) return toast.error("Pilih kategori terlebih dahulu");
    setBusy(true);
    const body = { title: f.title, summary: f.summary, content: f.content, category_id: f.category_id, image_url: f.image_url, author: f.author };
    try {
      if (id) await api.put(`/articles/${id}`, body); else await api.post("/articles", body);
      toast.success(id ? "Berita diperbarui" : "Berita diterbitkan");
      nav("/admin/berita");
    } catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={save} className="max-w-3xl space-y-6 fade-up" data-testid="article-editor-form">
      <h1 className="font-serif text-3xl font-extrabold">{id ? "Edit Berita" : "Tulis Berita Baru"}</h1>
      <div className="space-y-2"><Label>Judul</Label>
        <Input required minLength={3} value={f.title} onChange={set("title")} data-testid="article-title-input" /></div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div className="space-y-2"><Label>Kategori</Label>
          <Select value={f.category_id} onValueChange={set("category_id")}>
            <SelectTrigger data-testid="article-category-select"><SelectValue placeholder="Pilih kategori" /></SelectTrigger>
            <SelectContent>{cats.map((c) => <SelectItem key={c.id} value={c.id} data-testid={`category-option-${c.slug}`}>{c.name}</SelectItem>)}</SelectContent>
          </Select></div>
        <div className="space-y-2"><Label>Penulis</Label>
          <Input value={f.author} onChange={set("author")} data-testid="article-author-input" /></div>
      </div>
      <div className="space-y-2"><Label>Gambar Utama</Label><ImageInput value={f.image_url} onChange={set("image_url")} /></div>
      <div className="space-y-2"><Label>Ringkasan</Label>
        <Textarea rows={2} value={f.summary} onChange={set("summary")} data-testid="article-summary-input" /></div>
      <div className="space-y-2"><Label>Isi Berita</Label>
        <Textarea required rows={12} value={f.content} onChange={set("content")} placeholder="Pisahkan paragraf dengan baris baru" data-testid="article-content-input" /></div>
      <div className="flex gap-3">
        <Button type="submit" disabled={busy} data-testid="article-save-button">{busy ? "Menyimpan..." : id ? "Simpan Perubahan" : "Terbitkan"}</Button>
        <Button type="button" variant="outline" onClick={() => nav("/admin/berita")} data-testid="article-cancel-button">Batal</Button>
      </div>
    </form>
  );
}
